import { I18n } from '@calendly/i18n'
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, FilterIcon } from '@calendly/ui/components/icons'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import { Button, NumberWrapper, buttonOpenCss } from './styles'

export const FilterButton = ({ isModalOpen, openModal, closeModal, appliedFiltersCount }) => {
  const isTabletUp = useDeviceType('isTabletUp')
  const isPhone = useDeviceType('isPhone')

  const handleClick = () => {
    if (isModalOpen) {
      closeModal()
    } else {
      openModal()
    }
  }

  return (
    <Button
      aria-label="filter-button"
      onClick={handleClick}
      className={isModalOpen ? buttonOpenCss : undefined}
    >
      <FilterIcon />
      {isTabletUp && I18n.t('publisher.event_types.filter')}
      {!isModalOpen && !isPhone && <ArrowChevronDownMiniIcon />}
      {isModalOpen && !isPhone && <ArrowChevronUpMiniIcon />}
      {(appliedFiltersCount > 0) && (
        <NumberWrapper>
          {appliedFiltersCount}
        </NumberWrapper>
      )}
    </Button>
  )
}
